import {Helmet} from 'react-helmet-async';
import '../components/InformationPage.css';

function TermsOfServicePage() {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Medical Coding Classes Online</title>
        <meta
          name="description"
          content="Review the terms governing use of Medical Coding Classes Online lessons, practice quizzes, flashcards, and interactive study tools."
        />
        <link rel="canonical" href="https://medicalcodingclassesonline.com/terms" />
      </Helmet>
      <main className="information-page">
        <section className="information-hero">
          <div className="container">
            <span className="eyebrow">Website terms</span>
            <h1>Terms of Service</h1>
            <p>
              These terms describe the rules for using the Medical Coding Classes Online
              educational platform and its free study resources.
            </p>
          </div>
        </section>
        <section className="information-section">
          <div className="container information-layout">
            <article className="information-content">
              <h2>1. Acceptance of these terms</h2>
              <p>
                By accessing or using Medical Coding Classes Online, you agree to these Terms of
                Service and our Privacy Policy. If you do not agree, please do not use the website.
              </p>
              <h2>2. Educational platform</h2>
              <p>
                The platform provides self-paced study guides, practice quizzes, interactive
                flashcards, reference materials, and related educational tools. The content is
                intended to support independent foundational learning and exploration of medical
                billing and coding.
              </p>
              <h2>3. No certification or enrollment</h2>
              <p>
                Use of the website does not enroll you in a college, certification program, or
                accredited course. The platform does not issue academic credit, professional
                credentials, continuing education units, or certification exam eligibility.
              </p>
              <h2>4. Acceptable use</h2>
              <p>You agree to use the website lawfully and responsibly. You must not:</p>
              <ul>
                <li>Attempt to disrupt, damage, or gain unauthorized access to the website.</li>
                <li>Scrape, copy, republish, or commercially exploit content without permission.</li>
                <li>Use the platform to submit unlawful, abusive, or misleading material.</li>
                <li>Represent the website as an official certifying body or formal school.</li>
              </ul>
              <h2>5. Intellectual property</h2>
              <p>
                Unless otherwise noted, the website design, lessons, explanations, quizzes,
                flashcards, graphics, and original tools are owned by or licensed to Leadsurance.
                You may use the materials for personal, non-commercial study. No ownership rights
                are transferred to you.
              </p>
              <h2>6. Accuracy and changes</h2>
              <p>
                We work to keep educational content useful and accurate, but coding rules, payer
                policies, code sets, regulations, and professional standards can change. We may
                revise, suspend, or remove content and features at any time.
              </p>
              <h2>7. Third-party links and services</h2>
              <p>
                The website may link to third-party websites, tools, educational providers, or
                professional organizations. We do not control or guarantee third-party content,
                availability, privacy practices, or accuracy.
              </p>
              <h2>8. Disclaimer of warranties</h2>
              <p>
                The website is provided on an as-is and as-available basis. To the extent permitted
                by law, Leadsurance disclaims warranties of accuracy, uninterrupted availability,
                fitness for a particular purpose, and non-infringement.
              </p>
              <h2>9. Limitation of liability</h2>
              <p>
                To the extent permitted by law, Leadsurance will not be responsible for losses
                arising from reliance on study materials, interrupted access, lost local progress,
                or decisions made using the website. Users should verify current official guidance
                before applying concepts in professional work.
              </p>
              <h2>10. Contact</h2>
              <p>
                Questions about these terms may be sent to{' '}
                <a href="mailto:support@leadsurance.com">support@leadsurance.com</a>.
              </p>
            </article>
            <aside className="information-aside">
              <span className="aside-label">Study responsibly</span>
              <h2>Use current references</h2>
              <p>
                Practice content is a starting point. Always confirm current code-set, regulatory,
                payer, and employer requirements.
              </p>
            </aside>
          </div>
        </section>
      </main>
    </>
  );
}

export default TermsOfServicePage;